/**
 * 417 (#1464, US2, mock-up frame 3): the mileage package, offered by the quote on rentals under 24 hours of a car on
 * Cartrack at a pickup location with a zone. Package 1 is chosen to start with; the form prices the choice and sends it
 * with the booking. Real radio buttons, so each option is one labelled control.
 */
export interface MileageOffer {
  package1: { price_minor: number };
  package2: { price_minor: number; allowance_km: number };
  rate_minor_per_km: number;
  location_name: string | null;
}

const rm = (minor: number) => `RM ${(minor / 100).toFixed(2)}`;
const price = (minor: number) => (minor > 0 ? `+ ${rm(minor)}` : 'included');

export function MileagePackageStep({
  offer,
  value,
  onChange,
}: {
  offer: MileageOffer;
  value: 1 | 2;
  onChange: (next: 1 | 2) => void;
}) {
  const rate = `${rm(offer.rate_minor_per_km)}/km`;
  const area = offer.location_name ? `the ${offer.location_name} area` : 'the pickup area';
  const options = [
    {
      n: 1 as const,
      title: 'Package 1 · Stay in the area',
      detail: `Unlimited km inside ${area} · outside: ${rate} · ${price(offer.package1.price_minor)}`,
    },
    {
      n: 2 as const,
      title: 'Package 2 · Go anywhere',
      detail: `${offer.package2.allowance_km} km included · over: ${rate} · ${price(offer.package2.price_minor)}`,
    },
  ];
  return (
    <section
      data-testid="mileage-step"
      className="flex flex-col gap-3"
      aria-labelledby="mileage-heading"
    >
      <div className="flex flex-col gap-1">
        <h2 id="mileage-heading" className="text-base font-bold text-text">
          Mileage package
        </h2>
        <p className="text-sm text-text-muted">For rentals under 24 hours.</p>
      </div>
      <div className="flex flex-col gap-2" role="radiogroup" aria-labelledby="mileage-heading">
        {options.map((o) => {
          const on = value === o.n;
          return (
            <label
              key={o.n}
              data-testid={`mileage-option-${o.n}`}
              className={`flex cursor-pointer items-start gap-3 rounded-xl border p-4 transition-colors ${
                on
                  ? 'border-primary bg-surface-card'
                  : 'border-border bg-surface-card hover:border-border-light'
              }`}
            >
              <input
                type="radio"
                name="mileage-package"
                value={o.n}
                checked={on}
                onChange={() => onChange(o.n)}
                className="mt-1 h-4 w-4 shrink-0 accent-primary"
              />
              <span className="flex flex-col gap-1">
                <span className="text-sm font-semibold text-text">{o.title}</span>
                <span className="text-xs text-text-muted">{o.detail}</span>
              </span>
            </label>
          );
        })}
      </div>
    </section>
  );
}
